export default "__VITE_ASSET__BCnGKsrL__"